import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "general__checkbox_unchecked",
  "use": "general__checkbox_unchecked-usage",
  "viewBox": "0 0 18 18",
  "content": "<symbol viewBox=\"0 0 18 18\" xmlns=\"http://www.w3.org/2000/svg\" id=\"general__checkbox_unchecked\">\n  <rect fill=\"none\" x=\"1\" y=\"1\" width=\"16\" height=\"16\" rx=\"2\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol